import { componentsTranslation } from '@/assets/locales/components/components.translation.pl.ts';
import { NAMESPACE, Translations } from '@/assets/locales/en.ts';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.pl.ts';
import { layoutsTranslation } from '@/assets/locales/layouts/layouts.translation.pl.ts';
import { menuTranslation } from '@/assets/locales/menu/menu.translation.pl.ts';
import { pageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.pl.ts';
import { utilsTranslation } from '@/assets/locales/utils/utils.translation.pl.ts';
import { validationTranslation } from '@/assets/locales/validation/validation.translation.pl.ts';
import { viewsTranslation } from '@/assets/locales/views/views.translation.pl.ts';

export const pl: Translations = {
  [NAMESPACE]: {
    alerts: {
      error:
        'Operacja nie powiodła się, spróbuj ponownie lub skontaktuj się z administratorem aplikacji.',
      success: 'Operacja zakończona pomyślnie.',
    },
    components: componentsTranslation,
    fullText: {
      all: 'Wszystko',
      employees: 'Pracownicy',
      employeesTab: {
        certificates: 'Certyfikaty:',
        courses: 'Kursy:',
        experience: 'Doświadczenie:',
        location: 'Lokalizacja:',
        position: 'Stanowisko:',
        projects: 'Projekty:',
      },
      goBack: 'Powrót',
      maxResults: 'Maksymalna liczba wyników na stronie',
      missing: 'Brakujące:',
      more: 'więcej...',
      projects: 'Projekty',
      publications: 'Publikacje',
      resultCount: 'Liczba wyników wyszukiwania: ',
    },
    generalError: generalErrorTranslation,
    layouts: layoutsTranslation,
    menu: menuTranslation,
    pageTitles: pageTitlesTranslation,
    utils: utilsTranslation,
    validation: validationTranslation,
    views: viewsTranslation,
  },
};
